var $54ccb4bcf3ebc0a8$exports = {};
$54ccb4bcf3ebc0a8$exports = {
    "collapse": `Ahenda`,
    "columnResizer": `Veeru suuruse muutja`,
    "drag": `Lohista`,
    "expand": `Laienda`,
    "loading": `Laadimine...`,
    "loadingMore": `Laadi rohkem...`,
    "resizeColumn": `Muuda veeru suurust`,
    "sortAscending": `Sordi kasvavalt`,
    "sortDescending": `Sordi kahanevalt`
};


export {$54ccb4bcf3ebc0a8$exports as default};
//# sourceMappingURL=et-EE.module.js.map
